export default __webpack_public_path__ + "static/media/ChaltenUso30.1d988766.jpeg";